<template>
  <CardSection>
    <template #header>
      Monthly TxC Operational Reports
    </template>
    <template #body>
      <div class="row">
        <ReportSetView report-set-base-url="/report_sets/internal_qa" />
      </div>
    </template>
  </CardSection>
</template>

<script setup lang="ts">
// @ts-ignore
import ReportSetView from "@/src/components/rundown/ReportSetView.vue";
// @ts-ignore
import CardSection from "@/src/components/shared/CardSection.vue";
</script>